import { AutoActivationMode, OrganizationalUnit } from '@common/models';
import { GuidEmpty, naturalSort } from 'mbs-ui-kit';

export class UtilsHelper {
  static normalizeUnits(units: OrganizationalUnit[], options: { allUsersText: string; search: string }): OrganizationalUnit[] {
    const { allUsersText, search } = options;
    const baseUnits = search ? units : UtilsHelper.prependAllUsersUnit(units, allUsersText);

    return UtilsHelper.resolvePath(baseUnits);
  }

  private static resolvePath(units: OrganizationalUnit[]): OrganizationalUnit[] {
    if (units.length === 0) return units;

    return units.map((u) => ({
      ...u,
      Path: u?.Path || u?.Name
    }));
  }

  private static prependAllUsersUnit(units: OrganizationalUnit[], allUsersText: string): OrganizationalUnit[] {
    const notInUnits = units.find((u) => u.Id === GuidEmpty);
    const sortedUnits = units.filter((u) => u.Id !== GuidEmpty).toSorted((a, b) => naturalSort(a.Path, b.Path));
    const allUsersUnit = {
      Id: '',
      Path: allUsersText,
      AutoActivationMode: AutoActivationMode.Disabled
    } as OrganizationalUnit;

    return [allUsersUnit, ...(notInUnits ? [notInUnits] : []), ...sortedUnits];
  }

  /* Need for get to normalize value from the method getEmptyAttachedPolicy() */
  static convertPolicyId = (id: string): string => id || null;
}
